(() => {
  if (!customElements.get('fg-selected-total')) {
    customElements.define('fg-selected-total', class extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('product-info');
        this.onQuantity = () => this.update();
        this.product?.addEventListener('change', this.onQuantity);
        this.product?.addEventListener('input', this.onQuantity);
        this.update();
      }
      disconnectedCallback() {
        this.product?.removeEventListener('change', this.onQuantity);
        this.product?.removeEventListener('input', this.onQuantity);
      }
      update() {
        const input = this.product?.querySelector('.product-form__quantity input[name="quantity"]');
        const quantity = Math.max(1, Math.floor(Number(input?.value) || 1));
        const cents = Number(this.dataset.price);
        if (!Number.isSafeInteger(cents) || cents < 0) return;
        const amount = this.querySelector('[data-fg-selected-amount]');
        const count = this.querySelector('[data-fg-selected-quantity]');
        if (count) count.textContent = String(quantity);
        if (amount) amount.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {
          style: 'currency', currency: this.dataset.currency || 'USD', currencyDisplay: 'code'
        }).format(cents * quantity / 100);
      }
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-fg-open-bulk]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.getAttribute('href')?.slice(1));
    if (!(target instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    target.open = true;
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    target.querySelector('input[type="search"]')?.focus({ preventScroll: true });
  });
})();
